import { render } from "./lazy-render.vue?vue&type=template&id=40a35acc&ts=true"
import script from "./lazy-render.vue?vue&type=script&lang=ts"
export * from "./lazy-render.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__